// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/company';
import model_2 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/department';
import model_3 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/global';
import model_4 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/hotwords';
import model_5 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/lang';
import model_6 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/member';
import model_7 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/role';
import model_8 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/template';
import model_9 from '/Users/linqin/Documents/project/luosen_base/luosen_back/src/models/term';

export const models = {
model_1: { namespace: 'company', model: model_1 },
model_2: { namespace: 'department', model: model_2 },
model_3: { namespace: 'global', model: model_3 },
model_4: { namespace: 'hotwords', model: model_4 },
model_5: { namespace: 'lang', model: model_5 },
model_6: { namespace: 'member', model: model_6 },
model_7: { namespace: 'role', model: model_7 },
model_8: { namespace: 'template', model: model_8 },
model_9: { namespace: 'term', model: model_9 },
} as const
